const pxToRem = (px: number) => `${px / 16}rem`;
const ptToRem = (pt: number, k = 1) => (pt * k) / 14;
const ptToPx = (px: number, k = 1) => px * 1.3 * k;

export { ptToPx, pxToRem, ptToRem };
